import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

export function TagInput({ value = [], onChange, placeholder = "Type and press Enter", testid }) {
  const [draft, setDraft] = useState("");

  const add = (raw) => {
    const parts = raw.split(",").map((s) => s.trim()).filter(Boolean);
    if (!parts.length) return;
    const next = [...new Set([...value, ...parts])];
    onChange(next);
    setDraft("");
  };

  const remove = (tag) => onChange(value.filter((t) => t !== tag));

  return (
    <div data-testid={testid}>
      <Input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            add(draft);
          }
        }}
        onBlur={() => draft && add(draft)}
        placeholder={placeholder}
        data-testid={testid ? `${testid}-input` : undefined}
      />
      {value.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {value.map((tag) => (
            <span key={tag} className="inline-flex items-center gap-1 rounded-full border border-border bg-elevated px-2.5 py-1 text-xs text-foreground">
              {tag}
              <button type="button" onClick={() => remove(tag)} aria-label={`Remove ${tag}`}>
                <X className="h-3 w-3 text-muted-foreground hover:text-foreground" />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
